/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authManageModeration'

export { $nsid }

const main = l.permissionSet(
  $nsid,
  [
    l.permission('rpc', {
      inheritAud: true,
      lxm: [
        'app.bsky.actor.getPreferences',
        'app.bsky.actor.putPreferences',
        'app.bsky.graph.muteActor',
        'app.bsky.graph.muteActorList',
        'app.bsky.graph.muteThread',
        'app.bsky.graph.unmuteActor',
        'app.bsky.graph.unmuteActorList',
        'app.bsky.graph.unmuteThread',
      ],
    }),
    l.permission('repo', {
      action: ['create', 'update', 'delete'],
      collection: ['app.bsky.graph.block', 'app.bsky.graph.listblock'],
    }),
  ],
  {
    title: 'Manage Personal Moderation',
    'title:lang': {},
    detail:
      'Control over blocks, mutes, mod lists, mod services, and preferences.',
    'detail:lang': {},
  },
)

export { main }
